import { withStyles } from '@material-ui/core';
import EditCustomerForm from './Form.js';
const sharedPaperStyles = (theme) => ({
  top: 50,
  margin: '4 10 10 10',
  backgroundColor: theme.AppBGColor,
  transition: theme.transitions.create(['width'], {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowY: 'hidden',
  borderRadius: '4px'
});

const styles = (theme) => ({
  paperAnchor: {
    ...sharedPaperStyles(theme),
    zIndex: 50,
    borderTop:0,
  },  
  paperAnchorHighZIndex: {
    ...sharedPaperStyles(theme),
    zIndex: 1400
  },
  paperAnchorWhenNotification: {
    ...sharedPaperStyles(theme),
    top: 95
  },
  paperHidden: {
    height: 0,
    width: 0
  },
  backdrop: {
    position: 'absolute',
    backgroundColor: 'transparent'
  },
  modal: {
    position: 'absolute'
  }
});

const EditCustomerFullScreenDialog = ({
  classes,
  open,
  isHighZIndexRequired,
  isNotificationVisible,
  ...rest
}) => {
  const getPaperClass = () => {
    if (isHighZIndexRequired) {
      return classes.paperAnchorHighZIndex;
    } else if (isNotificationVisible) {
      return classes.paperAnchorWhenNotification;
    }
    return classes.paperAnchor;
  };

  return (
    <EditCustomerForm
      open={open}
      anchor="bottom"
      variant="persistent"
      drawerClasses={{
        paper: `${getPaperClass()} ${!open ? classes.paperHidden : ''}`,
        modal: classes.modal
      }}
      BackdropProps={{
        className: classes.backdrop
      }}
      {...rest}
    />
  );
};

export default withStyles(styles)(EditCustomerFullScreenDialog);
